var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavLogoEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 661 102.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6d6d6d;}.cls-2{fill:#005ed1;}.cls-3{fill:#c4c4c4;}.cls-4{fill:#0056a3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.05,58.53l9.07-11.35,2.61-3.27,1-1.26.22-.28,3.9-4.88v-7H35v7.33H55.36L53,40.76l-2.51,3.15L42.71,53.6l-4,4.93L35,63.25v7.16H65.85V63.08H45.41l2.43-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.43,51.22A51,51,0,0,1,89,85.77L81.1,75.89l-.61-.76a37.79,37.79,0,0,0-.75-48.72l1.6-2,6.87-8.61A51,51,0,0,1,102.43,51.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.91,85.14A37.83,37.83,0,0,1,14.12,58.53H28.51L40.23,43.9H14.12a37.82,37.82,0,0,1,52.8-27.08l5.16-6.44L75.5,6.11a51.3,51.3,0,0,0-49.75.66,51.59,51.59,0,0,0-12.45,10A51,51,0,0,0,.52,43.9a51.71,51.71,0,0,0,0,14.63A51.23,51.23,0,0,0,76.43,95.8L72,90.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.99 43.9 59.3 58.53 78.04 58.53 78.04 43.9 70.99 43.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.25,25.22V20.7h-17V44.8h17V40.28H130.34V34.8H142V30.28H130.34V25.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.1,25.22V20.7H167V44.8H184.1V40.28H172.18V34.8h11.66V30.28H172.18V25.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5,40.28V20.7h-5.17V44.8h15.35V40.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.58,20.7V35.84L195.43,20.7h-5.28V44.8h5.13V29.09L206.76,44.8h5V20.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.6,20.7v4.52h7V44.8h5.18V25.22h7V20.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.05,27.28c0-1.44,1.22-2.39,3.38-2.39a10.38,10.38,0,0,1,7,2.65l2.85-3.84a13.53,13.53,0,0,0-9.4-3.36c-5.66,0-9.14,3.32-9.14,7.35,0,9.06,13.88,6.12,13.88,10.32,0,1.41-1.34,2.67-4.19,2.67a10.55,10.55,0,0,1-7.66-3.29l-2.81,4c2.26,2.28,5.59,3.83,10.25,3.83,6.45,0,9.63-3.32,9.63-7.73C259.86,28.51,246.05,31.07,246.05,27.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.58,20.7h-6.44l-9.28,24.1h5.83l1.52-4.08h10.32l1.52,4.08h5.81Zm-7,15.5,3.75-10.36,3.77,10.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.28,35.62a7,7,0,0,0,5.31-7.15c0-4.48-3.11-7.77-8.12-7.77H290.19V44.8h5.14V25.22h5.41c2,0,3.58,1.22,3.58,3.22a3.27,3.27,0,0,1-3.58,3.29h-4.17l2.5,4.51,4.74,8.56h5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304.34,73a6.91,6.91,0,0,0,5.27-7.1c0-4.45-3.09-7.71-8.06-7.71h-11.2V82.09h5.1V62.65h5.37c2,0,3.56,1.22,3.56,3.2a3.24,3.24,0,0,1-3.56,3.26h-4.14l2.49,4.49,4.7,8.49h5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.25,58.17H133l-9.1,23.62h5.7l1.49-4h10.13l1.49,4h5.7Zm-6.83,15.19L136.1,63.2l3.69,10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.93,77.36V58.17h-5.06V81.79h15V77.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.82,67.79v3.83h9.79V67.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M193.08,77.36,204.24,62.2v-4H186.51V62.6h11.14L186.51,77.7v4.09h18V77.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.23,58.17h-6.3l-9.1,23.62h5.7l1.49-4h10.12l1.48,4h5.7ZM217.4,73.36l3.69-10.16,3.67,10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254,58.17v9.27H242.86V58.17h-5V81.79h5v-10H254v10h5.07V58.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.41,62.6V58.17h-16.7V81.79h16.7V77.36H271.74V72h11.42V67.55H271.74V62.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 353.15,
    y: 5.2,
    width: 1.77,
    height: 92.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.03,
    y: 30.26,
    width: 11.67,
    height: 40.74,
    rx: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.27,62.77l20.21-31.92a1.26,1.26,0,0,1,1.07-.59h10.81a.8.8,0,0,1,.68,1.21l-21.21,34.2a13.74,13.74,0,0,1-23.51-.26l-20-34a.79.79,0,0,1,.68-1.19h10.82a1.26,1.26,0,0,1,1.09.62l18.57,31.88A.47.47,0,0,0,450.27,62.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.47,60.4V40.34a.4.4,0,0,1,.39-.4h36a.39.39,0,0,0,.4-.39v-8.9a.39.39,0,0,0-.4-.39H501.27c-7.52,0-13.67,5.59-13.67,13.1V58.49c0,6.93,5.62,12,12.55,12h35.73a.39.39,0,0,0,.4-.39v-8.9a.4.4,0,0,0-.4-.39h-36A.4.4,0,0,1,499.47,60.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559,60.4V40.34a.4.4,0,0,1,.4-.4h36a.38.38,0,0,0,.39-.39v-8.9a.38.38,0,0,0-.39-.39H560.79c-7.51,0-13.66,5.59-13.66,13.1V58.49c0,6.93,5.61,12,12.54,12h35.74a.38.38,0,0,0,.39-.39v-8.9a.39.39,0,0,0-.39-.39h-36A.4.4,0,0,1,559,60.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.33,30.26h-28.4c-6.92,0-13.67,5.6-13.67,12.55V57.93c0,6.94,6.75,12.54,13.67,12.54h28.4c6.94,0,13.67-5.6,13.67-12.54V42.81C661,35.86,654.27,30.26,647.33,30.26Zm1.82,30.13a.41.41,0,0,1-.41.39H617.53a.38.38,0,0,1-.39-.39v-20a.39.39,0,0,1,.39-.39h31.21a.42.42,0,0,1,.41.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 505.32,
    y: 45.83,
    width: 30.95,
    height: 9.07,
    rx: 0.71
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogoEn);
export default __webpack_public_path__ + "static/media/nav_logo_en.f9d4f40d310a20f3232be54867bbbcf0.svg";
export { ForwardRef as ReactComponent };